
import { declination } from '@artmizu/utils';
import { computed } from '@vue/composition-api';
import type { ReviewRating } from '~/type/Review';
const __sfc_main = {};
__sfc_main.props = {
  link: {
    key: "link",
    required: true,
    type: String
  },
  isBought: {
    key: "isBought",
    required: true,
    type: Boolean
  },
  data: {
    key: "data",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const convertRateText = computed(() => {
    return props.data?.review?.reviewCount ? `${props.data.review.reviewCount} ${declination(props.data.review.reviewCount, ['отзыв', 'отзыва', 'отзывов'])}` : undefined;
  });
  const convertQuestionText = computed(() => {
    return props.data?.questionCount ? declination(props.data?.questionCount, ['вопрос', 'вопроса', 'вопросов']) : undefined;
  });

  /**
   * Когда пользователь не купил товар и нет отзывов и вопросов
   */
  const isNotPurchase = computed(() => !props.isBought && !props.data.questionCount && !props.data.review?.reviewCount);

  /**
   * Когда купил товар, но нет отзывов и вопросов
   */
  const isPurchase = computed(() => props.isBought && !props.data.questionCount && !props.data.review?.reviewCount);

  /**
   * Нужен для следующих кейсов:
   * 1. На карточке товара нет отзывов и вопросов, а клиент не совершал покупку этого товара - Отображает блоки “Нет отзывов” и “Спросить”
   * 2. На карточке товара нет отзывов и вопросов, а клиент совершил покупку этого товара - “Оценить” и “Спросить”
   * 3. Иначе показываем рейтинг, количество вопросов и отзывов
   */
  const getRateStatus = computed(() => {
    if (isPurchase.value || props.isBought) return 'оценить товар';else if (isNotPurchase.value || !convertRateText.value) return 'нет отзывов';else return convertRateText.value;
  });
  return {
    convertQuestionText,
    getRateStatus
  };
};
export default __sfc_main;
